import type { ShiftSettingRegionEntity } from './ShiftSettinfRegionEntity'

export class ShiftSettingEntity {
  id?: number
  generateJobPeriodInDays?: number
  numberOfGeneratedDays?: number
  shiftSettingRegions?: Array<ShiftSettingRegionEntity> | null
}
